import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _billing = {
    monthlyPrice: 'DOUBLE',
    yearlyPrice: 'DOUBLE',
    oneTimePrice: 'DOUBLE',
    meteredBilling: '_meteredBilling',
};
var _getPricingModelRequest = {};
var _getPricingModelResponse = { model: '_pricingModel' };
var _meteredBilling = {
    monthlyBaseFee: 'DOUBLE',
    additionalCharges: 'google.protobuf.DoubleValue',
};
var _plan = { billing: '_billing' };
var _pricingModel = { plans: '_plan' };
function resolveComWixpressAppserviceApiPricingPricingUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/pricing-api-proxy',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/pricing-api-proxy',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/pricing-api-proxy',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/pricing-api-proxy',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/pricing-api-proxy',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/pricing-api-proxy',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function getPricingModel(payload) {
    var _a = serializer(_getPricingModelRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPricingModelResponse, {
        _billing: _billing,
        _meteredBilling: _meteredBilling,
        _plan: _plan,
        _pricingModel: _pricingModel,
    }).fromJSON;
    function __getPricingModel(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.pricing.v1.pricing_entity',
            method: 'GET',
            methodFqn: 'com.wixpress.appservice.api.pricing.Pricing.GetPricingModel',
            url: resolveComWixpressAppserviceApiPricingPricingUrl({
                protoPath: '/api/v1/apps/{appId}/pricing-model',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPricingModel.fromReq = fromReq;
    __getPricingModel.__isAmbassador = true;
    return __getPricingModel;
}
//# sourceMappingURL=http.impl.js.map